import React from 'react';

import {SchemaTag, UnaffiliatedSchemaTag} from 'folder-items/FileConstants';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {ValidEntitiesForFieldPathQuery} from 'schemas/tags/__generated/ValidEntitiesForFieldPathQuery';

import {BaseBioentityLinkInputProps} from './BioentityLinkInputConstants';
import ControlledBioentityLinkInput from './ControlledBioentityLinkInput';

type ValidEntityGraphQL = NonNullable<
  NonNullable<
    ExtractByTypename<
      ValidEntitiesForFieldPathQuery['bioentity'],
      'BasicFolderItemNode'
    >['validEntitiesForFieldPathInfo']
  >['validEntities']
>[number];

export type BioentityLinkInputProps<T extends SchemaTag | UnaffiliatedSchemaTag> =
  BaseBioentityLinkInputProps<T> & {
    validEntities?: Array<ValidEntityGraphQL>;
    loadingValidEntities?: boolean;
  };

interface State {
  inputValue: string;
}

class BioentityLinkInput extends React.Component<
  BioentityLinkInputProps<SchemaTag | UnaffiliatedSchemaTag>,
  State
> {
  static defaultProps = {summarize: false};

  // Display the `inputValue` state instead of `this.props.tag.value` in the input field.
  //
  // A bioentity link's "text value" should only be used as the input value when there are no bioentity links
  // (we allow setting either raw text or linking to bioentities). However, all bioentity links have a
  // `value` prop because that text value is used for display in the expanded view.
  override state: State = {
    inputValue: this.props.tag.value && !this._getLinksAreDisplayed() ? this.props.tag.value : '',
  };

  _getLinksAreDisplayed(): boolean {
    return this.props.tag.targetFiles!.length > 0;
  }

  override render(): JSX.Element {
    return (
      <ControlledBioentityLinkInput
        {...this.props}
        inputValue={this.state.inputValue}
        onUpdateInputValue={(inputValue) => {
          this.setState({inputValue});
        }}
      />
    );
  }
}

export default BioentityLinkInput;
